<template>
  <v-card outlined class="pa-2 ma-2 text-left">
    <v-row>
      <v-col cols="1" class="pt-1">
        <PersonAvatar :avatar-filename="authorAvatarFilename" avatar-height="40"></PersonAvatar>
      </v-col>

      <v-col cols="11" class="overline text-right pt-1">
        {{ authorName }} -
        {{ showDate(pubDate, 'D MMMM YYYY') }}
      </v-col>
      <v-col cols="12" class="py-0">
        <span
          v-if="showMode === 'showing'"
          class="grey--text text--darken-2"
          style="white-space: pre-line;"
        >{{ text }}</span>
        <v-card v-else pa-0 sa-0 flat>
          <v-form v-model="formIsValid" ref="form">
            <v-textarea
              outlined
              :label="editingLabel"
              v-model="commentText"
              :rules="[rules.required]"
              hide-details="auto"
            ></v-textarea>
          </v-form>
        </v-card>
      </v-col>
    </v-row>

    <v-card-actions class="py-0">
      <v-spacer></v-spacer>
      <EditButton v-if="adminMode && showMode === 'showing'" @click="editingMode = true"></EditButton>

      <v-btn
        v-if="adminMode && showMode === 'showing'"
        icon
        :loading="apiLoadingData"
        @click="deleteComment"
      >
        <v-icon>mdi-delete</v-icon>
      </v-btn>
      <v-btn
        v-if="showMode === 'adding'"
        icon
        :loading="apiLoadingData"
        color="green"
        :disabled="!formIsValid"
        @click="addComment"
      >
        <v-icon>mdi-check-outline</v-icon>
      </v-btn>
      <v-btn
        v-if="showMode === 'editing'"
        icon
        :loading="apiLoadingData"
        color="green"
        :disabled="!formIsValid"
        @click="updateComment"
      >
        <v-icon>mdi-check-outline</v-icon>
      </v-btn>
      <v-btn
        v-if="showMode === 'editing' || showMode === 'adding'"
        icon
        color="red"
        @click="cancelEditing"
      >
        <v-icon>mdi-cancel</v-icon>
      </v-btn>
    </v-card-actions>
    <ConfirmDialog ref="confirm"></ConfirmDialog>
    <v-alert v-model="showErrorAlert" type="error" dismissible>
      {{
      errorMessage
      }}
    </v-alert>
  </v-card>
</template>

<script>
import APIService from '@/apiservices/APIService.js'
import { showDate } from '@/helpers/helpers.js'
import { authComputed, adminOptionsComputed } from '@/store/helpers.js'
import { editingLogicMixin } from '@/components/mixins/editing'
import PersonAvatar from '@/components/PersonAvatar.vue'
import ConfirmDialog from '@/components/ConfirmDialog.vue'
import EditButton from '@/components/EditButton.vue'
export default {
  components: {
    PersonAvatar,
    ConfirmDialog,
    EditButton
  },
  mixins: [editingLogicMixin],
  props: {
    commentId: {
      type: Number
    },
    authorId: {
      type: Number,
      required: true
    },
    authorName: {
      type: String,
      required: true
    },
    authorAvatarFilename: {
      type: String
    },
    text: {
      type: String,
      default: ''
    },
    pubDate: {
      type: String,
      default: new Date().toString()
    },
    articleId: {
      type: Number,
      required: true
    }
  },
  data() {
    return {
      commentText: '',

      rules: {
        required: value => !!value || 'Не, в пустом комменте нет смысла'
      }
    }
  },
  computed: {
    ...authComputed,
    ...adminOptionsComputed,
    showMode() {
      if (!this.commentId) {
        return 'adding'
      }
      if (this.editingMode) {
        return 'editing'
      }
      return 'showing'
    },
    editingLabel() {
      if (this.showMode == 'adding') {
        return 'Комментируйте, ' + this.loggedUserPersonName + '!'
      }
      return 'Исправляет ' + this.loggedUserPersonName
    }
  },

  methods: {
    showDate,
    //
    // Методы связаннные с добавлением, изменением и удалением коммента в базе
    // Остальные методы и переменные для изменений в базе берутся из миксина editing.js
    //
    initData() {
      this.commentText = this.text
    },

    setData() {
      const apiData = {}
      apiData.text = this.commentText
      return apiData
    },

    newData() {
      const apiData = {}
      apiData.author = this.authorId
      apiData.text = this.commentText
      apiData.pub_date = new Date() //тут должно быть this.pubDate, но какая-то фигн с пирведением дат и сторк и так не работает. надо бы исправить
      apiData.article = this.articleId
      return apiData
    },

    setFreshData() {
      this.commentText = ''
      this.$refs.form.resetValidation()
    },

    addComment() {
      this.addData(APIService.createComment)
    },

    updateComment() {
      this.updateData(APIService.updateComment, this.commentId)
    },

    deleteComment() {
      this.deleteData(APIService.deleteComment, this.commentId)
    }
  }
}
</script>
